<template>
  <div>
    <div class="mb-2" v-if="!isDisabled">
      <b-button
        class="ml-1"
        style="fontweight: 600"
        variant="primary"
        size="sm"
        type="submit"
        @click="insertField"
      >
        <i style="font-size: 1rem" class="flaticon2-add-1 pr-0"></i>
      </b-button>
    </div>
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th class="header-color text-center">STT</th>
          <th class="header-color text-center">Tên đợt thanh toán</th>
          <th class="header-color text-center">Số tiền thanh toán</th>
          <th class="header-color text-center">Ngày bắt đầu thanh toán</th>
          <th class="header-color text-center">Ngày kết thúc thanh toán</th>
          <!-- <th class="header-color text-center">Mô tả</th> -->
          <!-- <th class="header-color text-center">Chiết khấu</th> -->
          <th></th>
        </tr>
      </thead>
      <tbody
        v-for="(payment, index) in contractData.contractPaymentTerm"
        :key="index"
      >
        <tr class="heighRow">
          <td class="text-center" style="width: 4%">
            <span class="font-weight-bolder">{{ index + 1 }}</span>
          </td>
          <td>
            <b-input
              type="text"
              size="sm"
              class="input-style"
              v-model="payment.name"
              :disabled="isDisabled"
            ></b-input>
          </td>
          <td style="width: 20%">
            <b-input
              type="text"
              size="sm"
              class="input-style"
              v-model="payment.totalAmount"
              :disabled="isDisabled"
              v-mask="mask"
            ></b-input>
          </td>
          <td style="width: 20%">
            <b-input-group>
              <date-picker
                placeholder="Chọn ngày bắt đầu thanh toán"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="payment.fromDate"
                :disabled="isDisabled"
              ></date-picker>
            </b-input-group>
          </td>
          <td style="width: 20%">
            <b-input-group>
              <date-picker
                placeholder="Chọn ngày bắt đầu thanh toán"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="payment.toDate"
                :disabled="isDisabled"
              ></date-picker>
            </b-input-group>
          </td>
          <td style="width: 5%">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" no-caret right :disabled="isDisabled">
                <template slot="button-content">
                  <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i>
                </template>
                <!-- <b-dropdown-item @click="addProductGift(productItem)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="fas fa-gift"></i>
                    &nbsp; Thêm quà tặng
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!getInstallmentInterestZero"
                  @click.prevent="addProductAttach(productItem)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="fas fa-tags"></i>
                    &nbsp; Thêm SP bán kèm
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    onShowPrivateNote(productItem, `popover-note-${index}`)
                  "
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-notepad"></i>
                    &nbsp; Thêm ghi chú
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!getInstallmentInterestZero"
                  @click="changeProduct(productItem, 'main')"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-add-1"></i>
                    &nbsp; Đổi sản phẩm
                  </span>
                </b-dropdown-item> -->
                <b-dropdown-item @click="showDeleteAlert(index)">
                  <span style="color: #3f4254; font-size: 12px">
                    <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th style="text-align: end" colspan="2">Tổng :</th>
          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
            {{ formattedTotalPrice }}
          </td>
          <!-- <td></td>
          <td></td>
          <td></td> -->
          <!-- <td></td> -->
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
// xoa_dau, convertPrice,
import {
  formatDate,
  currencyMask,
  makeToastFaile,
  convertPrice,
  unMaskPrice,
} from '../../../utils/common';
import Swal from 'sweetalert2';

export default {
  props: ['contractData', 'isDisabled'],
  data() {
    return {
      mask: currencyMask,

      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
    };
  },
  computed: {
    formattedTotalPrice() {
      const totalPrice = this.contractData.contractPaymentTerm.reduce(
        (sum, item) => sum + Number(unMaskPrice(item.totalAmount)),
        0,
      );

      return convertPrice(totalPrice);
    },
  },
  methods: {
    formatDate,
    async showDeleteAlert(index) {
      const text = `Bạn muốn xoá điều khoản thanh toán này ra khỏi danh sách`;
      const alert = await this.showWarningAlert(text);
      if (alert.isConfirmed) {
        const countChildsItem = this.contractData.contractPaymentTerm.length;
        this.contractData.contractPaymentTerm.splice(
          index,
          countChildsItem + 1,
        );
      }

      //   if (alert.isConfirmed) {
      //     const index = this.getIndexContractDetail(product.id);

      //     if (index > -1) {
      //       const countChildsItem = this.contractData.contractPaymentTerm.length;
      //       this.contractData.contractPaymentTerm.splice(
      //         index,
      //         countChildsItem + 1,
      //       );
      //       this.numberedOrderItems();
      //     }
      //   }
    },
    showWarningAlert: function (text) {
      return Swal.fire({
        title: 'Xoá điều khoản chuyển khoản!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    getIndexContractPaymentTerm(id) {
      const index = this.contractData.contractPaymentTerm.findIndex(
        (item) => item.id === id,
      );
      if (index < 0) {
        makeToastFaile(`Không tìm thấy ${id} trong danh sách`);
        return;
      }
      return index;
    },
    insertField() {
      if (this.contractData.contractPaymentTerm.length > 10) {
        makeToastFaile('Không được tạo quá 10 điều khoản thanh toán');
        return;
      }
      const item = {
        name: null,
        totalAmount: 0,
        fromDate: null,
        toDate: null,
      };
      this.contractData.contractPaymentTerm.push(item);
    },
  },
};
</script>

<style></style>
